import React from 'react'
import Helmet from './Helmet'

const NotFound = () => {
  return (
    <Helmet title="Not Found">
        <p className="not-found">This page is not found.</p>
    </Helmet>

  )
}

export default NotFound